<template>
  <div class="module-cart-badge">
    <div class="badge__badge" @click="cartStore.overlay = true">
      <span class="badge__icon icon-cart-alternative-before"></span>
      <span class="counter">{{cartStore.items.length}}</span>
    </div>
    <div class="badge-hint" v-if="cartStore.savedCableConfigHint">
      <span>{{ $t('show.cableconfi.saved') }}</span>
    </div>
  </div>
</template>

<script setup>
import { useCartStore } from '@/stores/cart'
import {watch} from 'vue';

const cartStore = useCartStore()

watch(() => cartStore.savedCableConfigHint, () =>
{
  if (cartStore.savedCableConfigHint)
  {
    setTimeout(() =>
    {
      cartStore.savedCableConfigHint = false
    }, 3000)
  }
})
</script>
